import { useEffect } from "react";
import { Redirect, Route, Switch, useLocation } from "wouter";

import { Section } from "./ui/Section";

import {
  ChangePasswordDialog,
  DesktopMenu,
  LoadingModal,
  UserAgreementDialog,
} from "@/common/components";
import { ROUTES } from "@/common/config";
import { useAuth, useUser } from "@/common/hooks";
import {
  CreateOrderPage,
  DashboardPage,
  DirectoriesPage,
  DraftsPage,
  Forbidden,
  LoginPage,
  ModerationPage,
  NotFound,
  OrdersPage,
  ProfilePage,
  SobOrdersPage,
  TradingPage,
  UserManagementPage,
  ViewOrderPage,
  ModerationOrdersPage,
  NotificationsPage,
} from "@/pages";
export const Routes = () => {
  const {
    auth: { isAuthenticated, isWagonOwner, isCargoOwner, isAdmin },
    query: authQuery,
    logout,
  } = useAuth();

  const { user, query: userQuery, permissions } = useUser();
  const [, setLocation] = useLocation();

  useEffect(() => {
    if (!isAuthenticated) {
      setLocation(ROUTES.LOGIN);
    }
  }, [isAuthenticated]);

  if (authQuery.isPending || userQuery.isLoading) {
    return <LoadingModal isOpen={true} />;
  }

  if (!isAuthenticated) {
    return (
      <Section>
        <Switch>
          <Route path={ROUTES.LOGIN} component={LoginPage} />
          <Route path={ROUTES.NOT_FOUND}>
            <Redirect to={ROUTES.LOGIN} />
          </Route>
        </Switch>
      </Section>
    );
  }

  if (!user) {
    return null;
  } else if (!user.changePassword) {
    return (
      <Section>
        <ChangePasswordDialog
          isOpen={!userQuery.isFetching}
          onSave={userQuery.refetch}
          onClose={logout}
        />
      </Section>
    );
  } else if (!user.accepted) {
    return (
      <Section>
        <UserAgreementDialog
          isOpen={!userQuery.isFetching}
          onAccept={userQuery.refetch}
          onClose={logout}
        />
      </Section>
    );
  }

  return (
    <main className="flex md:min-h-screen min-h-[calc(100vh-80px)]">
      <DesktopMenu />
      <article className="flex-1 md:p-6 p-4 md:pt-[4.5rem] pt-4">
        <Switch>
          <Route path={ROUTES.ROOT}>
            {isAdmin ? (
              <Redirect to={ROUTES.MODERATION_ORDERS} />
            ) : isWagonOwner ? (
              <Redirect to={ROUTES.ORDERS} />
            ) : (
              <DashboardPage />
            )}
          </Route>

          <Route path={ROUTES.ORDERS}>{isWagonOwner ? <OrdersPage /> : <Forbidden />}</Route>

          <Route path={ROUTES.PROFILE}>
            {permissions?.profile.vew_profile ? <ProfilePage /> : <Forbidden />}
          </Route>

          <Route path={ROUTES.CREATE_ORDER}>
            {permissions?.applications.create_application ? <CreateOrderPage /> : <Forbidden />}
          </Route>

          <Route path={ROUTES.ORDER_ID}>{(params) => <ViewOrderPage orderId={params.id} />}</Route>

          <Route path={ROUTES.EDIT_ORDER}>
            {(params) => <CreateOrderPage orderId={params.id} />}
          </Route>

          <Route path={ROUTES.DRAFTS}>{isCargoOwner ? <DraftsPage /> : <Forbidden />}</Route>

          <Route path={ROUTES.EDIT_DRAFT}>
            {(params) => <CreateOrderPage orderId={params.id} />}
          </Route>

          <Route path={ROUTES.TRADING}>{isCargoOwner ? <TradingPage /> : <Forbidden />}</Route>

          <Route path={ROUTES.SOB_ORDERS}>{isWagonOwner ? <SobOrdersPage /> : <Forbidden />}</Route>

          <Route path={ROUTES.MODERATION_ORDERS}>
            {isAdmin && permissions?.applications.moderate_application ? (
              <ModerationOrdersPage />
            ) : (
              <Forbidden />
            )}
          </Route>

          <Route path={ROUTES.MODERATION}>
            {permissions?.admin_panel.application_management ? <ModerationPage /> : <Forbidden />}
          </Route>

          <Route path={ROUTES.USER_MANAGEMENT}>
            {permissions?.admin_panel.user_management ? <UserManagementPage /> : <Forbidden />}
          </Route>
          <Route path={ROUTES.DIRECTORIES}>
            {permissions?.admin_panel.loading_books ? <DirectoriesPage /> : <Forbidden />}
          </Route>

          <Route path={ROUTES.NOTIFICATIONS} component={NotificationsPage} />

          <Route path={ROUTES.NOT_FOUND} component={NotFound} />

          {/* <Route path={ROUTES.MY_TRADES} component={MyTradesPage} /> */}
          {/* <Route path={ROUTES.TRADE_ID}>
            {(params) => <TradeDetailPage requestId={params.id} />}
          </Route> */}
          {/* <Route path={ROUTES.OFFERS_REVIEW} component={OffersReviewPage} /> */}
          {/* <Route path={ROUTES.NOTIFICATION_SETTINGS} component={NotificationSettingsPage} /> */}
          {/* <Route path={ROUTES.CONTENT_MANAGEMENT} component={ContentManagementPage} /> */}
          {/* <Route path={ROUTES.REPORTS} component={ReportsPage} /> */}
          {/* <Route path={ROUTES.NEWS} component={NewsPage} /> */}
        </Switch>
      </article>
    </main>
  );
};
